<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Image Processing</h1>
    </header>
    <section id="modal-body">

        <label i18n class="image-uploader" for="image-uploader">Upload Image</label>
        <input id="image-uploader" type="file" (change)="fileChangeEvent($event)" />
        <br />
        <br />
        <button i18n class="filledbtn" (click)="rotateLeft()">Rotate left</button>
        <button i18n class="filledbtn" (click)="rotateRight()">Rotate right</button>
        <button i18n class="filledbtn" (click)="flipHorizontal()">Flip horizontal</button>
        <button i18n class="filledbtn" (click)="flipVertical()">Flip vertical</button>
        <br />
        <br />
        <button i18n class="filledbtn" (click)="toggleContainWithinAspectRatio()" *ngIf="!containWithinAspectRatio">
            Fill Aspect Ratio
        </button>
        <button i18n class="filledbtn" (click)="toggleContainWithinAspectRatio()" *ngIf="!containWithinAspectRatio">
            Contain Within Aspect Ratio
        </button>
        <button i18n class="filledbtn" (click)="resetImage()">Reset image</button>
        <br />
        <br />
        <input [(ngModel)]="rotation" placeholder="Rotation" type="number" (keyup)="updateRotation()"
            class="zoominput" /> <button i18n class="filledbtn" (click)="zoomOut()">Zoom -</button> <button i18n class="filledbtn"
            (click)="zoomIn()">Zoom
            +</button>

        <div class="image-box">
            <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="cropRateX / cropRateY"
                [resizeToWidth]="300" [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                [style.display]="showCropper ? null : 'none'" format="png" (imageCropped)="imageCropped($event)"
                (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady($event)"
                (loadImageFailed)="loadImageFailed()"></image-cropper>
        </div>
        <img class="preview" [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" />

    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" (click)="applyCrop()">
            OK
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Cancel
        </button>
    </footer>
</div>